import React from 'react';

const DefaultAvatar = ({ className, size = 'medium', initials = null }) => {
  const sizeMap = {
    small: 32,
    medium: 40,
    large: 48,
    xlarge: 64
  };

  const avatarSize = sizeMap[size] || sizeMap.medium;

  if (initials) {
    return (
      <div 
        className={`${className} default-avatar-with-initials`}
        style={{
          width: avatarSize,
          height: avatarSize,
          borderRadius: '50%',
          background: 'linear-gradient(135deg, #D6A464 0%, #E6C088 50%, #F4D4A3 100%) !important',
          color: '#3B0618 !important',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: Math.max(14, avatarSize * 0.35),
          fontWeight: '700 !important',
          fontFamily: 'Montserrat, sans-serif',
          textTransform: 'uppercase',
          letterSpacing: '1px',
          boxShadow: '0 4px 16px rgba(214, 164, 100, 0.4), inset 0 1px 0 rgba(255, 255, 255, 0.3) !important',
          border: '2px solid rgba(255, 255, 255, 0.2) !important',
          position: 'relative',
          overflow: 'hidden'
        }}
      >
        {/* Shine effect */}
        <div style={{
          position: 'absolute',
          top: '-50%',
          left: '-50%',
          width: '200%',
          height: '200%',
          background: 'linear-gradient(45deg, transparent 30%, rgba(255, 255, 255, 0.3) 50%, transparent 70%)',
          animation: 'avatarShine 3s ease-in-out infinite'
        }} />
        
        {/* Text shadow for better readability */}
        <span style={{
          position: 'relative',
          zIndex: 1,
          textShadow: '0 1px 2px rgba(0, 0, 0, 0.2)',
          filter: 'drop-shadow(0 1px 1px rgba(255, 255, 255, 0.3))'
        }}>
          {initials}
        </span>
        
        <style jsx>{`
          @keyframes avatarShine {
            0% { transform: translateX(-100%) translateY(-100%) rotate(45deg); }
            50% { transform: translateX(100%) translateY(100%) rotate(45deg); }
            100% { transform: translateX(-100%) translateY(-100%) rotate(45deg); }
          }
        `}</style>
      </div>
    );
  }

  return (
    <svg
      className={`${className} default-avatar-svg`}
      width={avatarSize}
      height={avatarSize}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" r="12" fill="#4A1534" />
      <path
        d="M12 6C13.6569 6 15 7.34315 15 9C15 10.6569 13.6569 12 12 12C10.3431 12 9 10.6569 9 9C9 7.34315 10.3431 6 12 6Z"
        fill="#D3B87A"
      />
      <path
        d="M12 13C14.7614 13 17 15.2386 17 18V20C17 20.5523 16.5523 21 16 21H8C7.44772 21 7 20.5523 7 20V18C7 15.2386 9.23858 13 12 13Z"
        fill="#D3B87A"
      />
    </svg>
  );
};

export default DefaultAvatar;
